// the API serializes an empty/non-sequentially-keyed PHP array as a JSON
// object instead of an array, so a to-many relation isn't always an array
export function toArray(value) {
    if (!value) {
        return [];
    }

    return Array.isArray(value) ? value : Object.values(value);
}
